import { useEffect } from 'react';

const useOnMount = (cb: () => any) => useEffect(cb, [cb]);

export default useOnMount;
